declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newrelic: any;
  }
}

// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/add-page-action/
export function addPageAction(name: string, attributes: unknown): void {
  try {
    if (window?.newrelic?.addPageAction) {
      window.newrelic.addPageAction(name, attributes);
    }
  } catch {
    // since the newrelic script has not been loaded or blocked by adblockers,
    // we can not log to newrelic, so we silent ignore
    return;
  }
}

// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api
export function noticeError(error: unknown, attributes: unknown): void {
  try {
    if (window?.newrelic?.noticeError) {
      window.newrelic.noticeError(error, attributes);
    }
  } catch {
    // since the newrelic script has not been loaded or blocked by adblockers,
    // we can not log to newrelic, so we silent ignore
    return;
  }
}
